import React from "react";
import { Button } from "@mui/material";
import { TopLeftButton } from "./styles";

// Inline SVG replacement for Iconify "eva:arrow-ios-back-fill"
const BackArrowIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 2 }}>
    <path d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z" />
  </svg>
);

export const ExitButton = ({ onClick }: { onClick: () => void }) => (
  <TopLeftButton>
    <Button variant="outlined" onClick={onClick} aria-label="Exit" sx={{ paddingRight: "18px" }}>
      <BackArrowIcon />
      Exit
    </Button>
  </TopLeftButton>
);
